import { CustomerType } from '@features/contacts/enums/customerType'
import { InvoiceComplianceMode } from '@features/invoices/enums/invoiceComplianceMode'
import { PredefinedCustomerValues } from '@features/invoices/types/predefinedCustomerValues'
import { getCustomerMissingFields } from '@features/invoices/utils/getCustomerMissingFields'

interface GetMissingCustomerComplianceDetailsOptions {
  complianceMode: InvoiceComplianceMode
  customerValues: PredefinedCustomerValues
}

interface MissingCustomerComplianceDetails {
  isMissingCustomerAddress: boolean
  isMissingCustomerDetails: boolean
  isMissingCustomerTaxInfo: boolean
}

export const getMissingCustomerComplianceDetails = ({
  complianceMode,
  customerValues,
}: GetMissingCustomerComplianceDetailsOptions): MissingCustomerComplianceDetails => {
  const { address, customerType, isAddressExempt, isVatExempted, vatNumber } = customerValues ?? {}
  const { city, country, pobox, streetAddress1 } = address ?? {}

  const { isMissingAddress, isMissingDetails, isMissingTaxInfo } = getCustomerMissingFields({
    city,
    complianceMode,
    country,
    eInvoiceAddress: undefined,
    isAddressExempt,
    isIndividual: customerType === CustomerType.Individual,
    isVatExempted,
    street: streetAddress1,
    vatNumber,
    zipCode: pobox,
  })

  return {
    isMissingCustomerAddress: isMissingAddress,
    isMissingCustomerDetails: isMissingDetails,
    isMissingCustomerTaxInfo: isMissingTaxInfo,
  }
}
